export const aliasToString = record => {
    if (!record) return ' ';

    return record.aliasType === 'alias' ? `${record.name} (${record.software.version})` : record.name;
};
